import React from 'react';
import { Link } from 'react-router-dom';
import './UnderConstruction.css';

const UnderConstruction = () => {
  return (
    <div className="under-construction">
      <div className="under-construction__content">
        <h1 className="under-construction__title">under construction</h1>
        <p className="under-construction__text">
          this page is currently being built. check back soon.
        </p>
        <Link to="/home" className="under-construction__link">
          back to home
        </Link>
      </div>
    </div>
  );
};

export default UnderConstruction;
